import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';
import { ROUTES, resolveBaseRoute } from './routes';
import PageNotFound from '../pages/PageNotFound/PageNotFound';


const ROUTES_INFO = Object.freeze([
    {
      name: 'TemplateListing', 
      ROUTES_KEY: 'TIMETABLE_TEMPLATE_LISTING',
      Page: LazyComponentWithSuspense(() => import('../pages/TimeTable/TemplateListing'))
    },
    {
      name: 'CreateTemplate', 
      ROUTES_KEY: 'TIMETABLE_CREATE_TEMPLATE',
      Page: LazyComponentWithSuspense(() => import('../pages/TimeTable/CreateTemplate'))
    },
    {
      name: 'TemplateExcelUploadPage',
      ROUTES_KEY: 'TIMETABLE_UPLOAD_EXCEL',
      Page: LazyComponentWithSuspense(() => import('../pages/TimeTable/TemplateExcelUploadPage')),
    },
    {
      name: 'EditTemplate', 
      ROUTES_KEY: 'TIMETABLE_EDIT_TEMPLATE',
      Page: LazyComponentWithSuspense(() => import('../pages/TimeTable/EditTemplate'))
    },
    {
      name: 'MarkAttendance', 
      ROUTES_KEY: 'TIMETABLE_SLOT_MARK_ATTENDANCE',
      Page: LazyComponentWithSuspense(() => import('../pages/TimeTable/Attendance/MarkAttendance'))
    },
    {
      name: 'ViewAttendance',
      ROUTES_KEY: 'TIMETABLE_View_ATTENDANCE',
      Page: LazyComponentWithSuspense(() => import('../pages/TimeTable/Attendance/ViewAttendance'))
    },
    {
      name: 'UserTimetable', 
      ROUTES_KEY: 'TIMETABLE_USER',
      Page: LazyComponentWithSuspense(() => import('../pages/TimeTable/UserTimetable'))
    }
])


export default function TimeTableRoutes() {
  return (
    <Routes>

      {
        ROUTES_INFO.map(({name, ROUTES_KEY, Page}, index) => (
          <Route
            key={name ?? index}
            path={resolveBaseRoute(ROUTES[ROUTES_KEY])}
            element={<Page/>}
          />
        ))
      }

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
